import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarMixNovoOrcamento(axios, parametros) {        
    parametros.operacao = 'buscarMixNovoOrcamento'

    let retorno = {}

    await axios.santriPOST('/rest/orcamento', parametros, 60, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarMixNovoOrcamento.js